import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import lozad from 'lozad';

export const ShopWomen = () => {

  useEffect(() => {
    const observer = lozad(); // Initialize lozad
    observer.observe(); // Start observing
  }, []);

  // Use state to track the active tab
  const [activeTab, setActiveTab] = useState("all"); // Initialize with the 'all' tab

  // Function to handle tab click
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    document.title = 'Shop Women'; // Set the title to "Shop Women" when this component mounts
  }, []);
  return (
  <>
    <section className="bg lozad py-5" data-background-image="images/banner-1.jpg">
       <div className="container py-5">
          <div className="row text-white text-center py-5">
            <div className="col py-5" data-aos="fade-down" data-aos-duration="1000">
              <h2 className="f-50 fw-700">Shop Women</h2>
            </div>
          </div>
       </div>
    </section>

    <section className="special-offer py-5">
        <div className="container py-5">
          <div className="row py-5">
            <div className="tab-content" id="myTabContent">
              <div className={`tab-pane fade ${ activeTab === "all" ? "show active" : ""}`} id="all-tab-pane">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p1.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Linen crochet trim</h6>
                        <span>$191.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p2.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Heartland Alabama</h6>
                        <span>$300.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p3.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Mermaid pencil midi</h6>
                        <span>$250.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p4.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Criss-cross</h6>
                        <span>$191.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p5.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">V neck bodycon</h6>
                        <span>$200.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p6.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">cosmic cornucopia</h6>
                        <span>$500.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p7.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Tenku remastered</h6>
                        <span>$300.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p8.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Lined hoodie</h6>
                        <span>$150.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className={`tab-pane fade ${ activeTab === "men" ? "show active" : ""}`} id="men-tab-pane">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p2.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Heartland Alabama</h6>
                        <span>$300.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p4.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Criss-cross</h6>
                        <span>$191.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className={`tab-pane fade ${ activeTab === "women" ? "show active" : ""}`} id="women-tab-pane">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p1.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Linen crochet trim</h6>
                        <span>$191.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-lg-3 col-md-6 mt-4">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p3.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Mermaid pencil midi</h6>
                        <span>$250.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p5.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">V neck bodycon</h6>
                        <span>$200.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p6.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">cosmic cornucopia</h6>
                        <span>$500.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p7.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Tenku remastered</h6>
                        <span>$300.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 mt-4 ">
                    <a href="#" className="product">
                      <div className="product-image">
                        <img data-src="images/p8.jpg" className="lozad" alt="product images" />
                      </div>
                      <div className="product-text mt-2">
                        <h6 className="fw-600">Lined hoodie</h6>
                        <span>$150.00</span>
                        <div className="cart mt-4">
                          <a href="#" className="btn-1 ">
                            ADD TO CART
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  </>
  );
};